import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface StateProps {
  /** "Loading", "Empty", "Four intents". */
  title: string;
  /** One line of context where the state needs one - how to try it, a caveat. */
  note?: string;
  children: ReactNode;
}

/**
 * One state of one component: an h3 under the entry's h2, then the component
 * in that state. Every example file uses this, so the page's heading order is
 * built in rather than re-decided per example.
 */
export function State({ title, note, children }: StateProps) {
  return (
    // data-example marks deliberately loading-looking content - skeletons,
    // busy tables - so the browser tests' "wait until the page has finished
    // loading" does not wait forever on states that are the point.
    <Box sx={{ mt: 3 }} data-example>
      <Typography component="h3" variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        {title}
      </Typography>
      {note ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {note}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
}
